import React, { useEffect, useState } from 'react';
import { Container, Alert } from 'react-bootstrap';
import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';
import axiosInterceptor from '../../axiosInterceptor';
import loader from '../../assets/images/loading.gif';
import '../../styles/loader.css';

function CallBackPage() {
    const history = useHistory();
    const location = useLocation();

    const [loaderStatus, setLoaderStatus] = useState(true);
    const [emailSubmit, setEmailSubmit] = useState(false);

    useEffect(() => {
        (async () => {
            const { oauth_token, oauth_verifier } = queryString.parse(
                window.location.search
            );
            
            // If URL contains both oauth_token and oauth_verifier tokens after successful twitter login
            if (oauth_token && oauth_verifier) {
                try {
                    //Oauth Step 3
                    // Update Access Tokens and Secret tokens in DB
                    const token_data = await axiosInterceptor().post(
                        'twitter/auth/access_token',
                        {
                            oauth_token: oauth_token,
                            oauth_verifier: oauth_verifier
                        }
                    );
                    
                    // Successful Oauth Step 3
                    if (token_data?.data?.success) {
                        // Get User Profile Information from Twitter API
                        const profile_data = await axiosInterceptor().post(
                            'twitter/auth/getProfileInfo',
                            { oauth_token: oauth_token }
                        );
                        
                        // User has verified twitter account
                        if (profile_data?.data?.verified) {
                            history.push('/addEmail', {
                                username: ''
                            });
                        } 
                        // User don't have verified twitter account
                        else {
                            localStorage.setItem(
                                'access_token',
                                profile_data?.data?.accessToken
                            );
                            
                            // Check user is legit or not
                            const user_check = await axiosInterceptor().post(
                                'twitter/checkAndCreateMoralsUser',
                                {
                                    username: profile_data?.data?.username
                                }
                            );
                            
                            // Created new user
                            if (user_check?.data?.check == 'Created User') {
                                // Crawl Twitter Data
                                collectData(profile_data);
                            }

                            // Add Email
                            if (
                                user_check?.data?.check == 'Created User' ||
                                (user_check?.data?.check == 'Existing User' &&
                                    user_check?.data?.email == ' ')
                            ) {
                                history.push('/addEmail', {
                                    username: profile_data?.data?.username
                                });
                            } 
                            // Existing User
                            else if (
                                user_check?.data?.check == 'Existing User'
                            ) {
                                // Check if YourMorals user has verified email or not
                                const user_status_check =
                                    await axiosInterceptor().post(
                                        'twitter/checkUserStatus',
                                        {
                                            username:
                                                profile_data?.data?.username
                                        }
                                    );
                                // Email Not verified, Logout
                                if (user_status_check?.data.check != 'Valid') {
                                    await logout();
                                } 
                                // Email Verified and send to survey page
                                else {
                                    let user = {
                                        token: localStorage.getItem(
                                            'access_token'
                                        ),
                                        role: 'participant',
                                        email: user_check?.data?.email
                                    };

                                    localStorage.setItem(
                                        'user',
                                        JSON.stringify(user)
                                    );
                                    localStorage.setItem(
                                        'portal',
                                        'yourmorals-twittersso'
                                    );
                                    history.push('/');
                                }
                            } 
                            // Authorization failed
                            else {
                                history.push('/');
                            }
                        }
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        })();
    }, []);

    // Crawl Twitter Data
    let collectData = async (profile_data) => {
        axiosInterceptor().post('twitter/getUserInfo', {
            username: profile_data?.data?.username,
            bio: profile_data?.data?.bio,
            portal: 'your-morals'
        });
    };

    // Logout functionality
    let logout = async () => {
        setEmailSubmit(true);
        let i = 0;
        const interval = setInterval(async () => {
            await axiosInterceptor().post('twitter/auth/logout', {
                oauth_token: localStorage.getItem('oauth_token')
            });
            localStorage.removeItem('access_token');
            localStorage.removeItem('oauth_token');
            localStorage.removeItem('portal');
            history.push('/');
            i += 1;
            if (i === 1) {
                clearInterval(interval);
                setEmailSubmit(false);
            }
        }, 5 * 1000);
    };

    return (
        <Container>
            {loaderStatus && (
                <div className="blur-screen">
                    <img src={loader} alt="preview" className="loader-image" />
                </div>
            )}
            {!loaderStatus && (
                <Alert variant="danger" className="text-center">
                    You are ineligible for this Research Survey. Thanks for your
                    time.
                </Alert>
            )}
            {emailSubmit && (
                <>
                    <br />
                    <Alert variant="success" className="text-center">
                        Email Sent. Please check your email to verify your
                        email.
                    </Alert>
                </>
            )}
        </Container>
    );
}

export default CallBackPage;
